import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F0F0F0\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#000\" d=\"M3.515 20.485c-4.687-4.686-4.687-12.284 0-16.97L10.435 12z\"></path><path fill=\"#FFDA44\" d=\"M10.434 12 1.591 6.024a12 12 0 0 0-.724 1.49L5.344 12 .867 16.488q.313.772.723 1.487z\"></path><path fill=\"#6DA544\" d=\"M23.897 10.435H10.433l-6.92-6.92a12 12 0 0 0-1.923 2.51L7.555 12 1.59 17.975c.53.92 1.177 1.764 1.923 2.51l6.92-6.92h13.464a12.1 12.1 0 0 0 0-3.13\"></path><path fill=\"#0052B4\" d=\"M4.695 21.518a11.95 11.95 0 0 0 7.306 2.48c5.545 0 10.21-3.76 11.587-8.869H11.084z\"></path><path fill=\"#D80027\" d=\"M23.588 8.869c-1.377-5.11-6.042-8.87-11.587-8.87C9.251 0 6.72.925 4.695 2.48l6.39 6.389z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }